import WorkBlock from "domain/WorkBlock";
import React from "react";
import HeaderWrapper from "./HeaderWrapper";
import Heading from "./Heading";

export default function WorkBlockHeader({ workBlockLayout, block, code }) {
  const description = WorkBlock.description(block, workBlockLayout);

  return (
    <HeaderWrapper>
      {description && <Heading>{description}</Heading>}
      {description && <span>&nbsp;•&nbsp;</span>}
      <span>{code}</span>
    </HeaderWrapper>
  );
}
